import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Each Hall of Fame edition is a locked top 20 for its period. Hidden while only one is published. */
export const useEditions = () => {
  const [editions, setEditions] = useState([]);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    api
      .get("/hall-of-fame/editions")
      .then((r) => {
        setEditions(r.data.editions || []);
        setCurrent(r.data.current);
      })
      .catch(() => setEditions([]));
  }, []);

  return { editions, current, selected: current, setCurrent };
};

export const EditionTabs = ({ editions, selected, onSelect }) => {
  if (!editions || editions.length < 2) return null;
  return (
    <div className="mt-10 flex flex-wrap gap-1" data-testid="edition-tabs">
      {editions.map((e) => (
        <button
          key={e.edition}
          onClick={() => onSelect(e.edition)}
          data-testid={`edition-tab-${e.edition}`}
          className={`px-5 py-2.5 text-[0.62rem] font-bold uppercase tracking-[0.18em] transition-colors ${
            selected === e.edition
              ? "bg-ochre text-black"
              : "border border-zinc-800 text-zinc-400 hover:border-ochre hover:text-ochre"
          }`}
        >
          {e.label || `Edition ${e.edition}`}
        </button>
      ))}
    </div>
  );
};
